import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
// import { getFunctions } from 'firebase/functions';  // Comment this out if not using Functions

const firebaseConfig = {
  apiKey: 'AIzaSyDtInkKy-z56q1leeeYI5LlqMgnhiBe1Iw',
  authDomain: 'brissbella-academy.firebaseapp.com',
  databaseURL: 'https://brissbella-academy-default-rtdb.firebaseio.com',
  projectId: 'brissbella-academy',
  storageBucket: 'brissbella-academy.firebasestorage.app',
  messagingSenderId: '245972078794',
  appId: '1:245972078794:web:5157ec698418f2e54ce433',
  measurementId: 'G-6HB9PSE62W',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get Firebase services
export const auth = getAuth(app);
export const db = getDatabase(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');
// export const functions = getFunctions(app);  // Comment this out if not using Functions

export default app;
